import templateUrl from './work-order-manual-claim-list.component.html';

export const WorkOrderManualClaimListComponent = {
    controller: WorkOrderManualClaimListController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        workOrderClaims: "<",
        viewDetails: "&",
        approveClaim: "&"
    }
};

function WorkOrderManualClaimListController() {
    const vm = this;

    vm.viewDetails;
    vm.canEdit = canEdit;
    vm.workOrderClaims;
    vm.onViewDetails = onViewDetails;
    vm.onApproveClaim = onApproveClaim;
    vm.pageSize = 10;
    vm.pageNumber = 1;

    function onViewDetails(claim) {
        vm.viewDetails({ claim: claim });
    }
    function onApproveClaim(claim) {
        vm.approveClaim({ claim: claim });
    }
    function canEdit(claim) {
        return !claim.Approved;
    }
}
